import React from "react";
import { RevenueSection } from "./revenue-section.component";
import { TopSalesRepSection } from "./top-sales-rep-section.component";
import { TrialPerformanceSection } from "./trial-performance-section.component";
import { SalesPerformanceSection } from "./sales-performance-section.component";
import styles from "./index.module.scss";
import { DateFilterDropdown } from "../date-filter-dropdown";
import { DistributorFilterDropdown } from "./distributor-filter-dropdown.component";

export const TrialPerformance = ({ isDistributor = false }) => {
  if (!isDistributor) {
    const statsData = [
      { label: "Distributors", value: "4" },
      { label: "Total MSPs", value: "2500" },
      { label: "Total Clients", value: "3500" },
      { label: "Total Prospects", value: "1500" },
    ];

    return (
      <article className={styles.container}>
        <div className={styles.filtersRow}>
          <DistributorFilterDropdown />
        </div>

        <header className={styles.sectionHeader}>
          <div className={styles.sectionHeaderContent}>
            <h2 className={styles.sectionTitle}>
              Total Stats
            </h2>
          </div>
        </header>

        <section className={styles.simpleStatsSection}>
          {statsData.map((stat, index) => (
            <article
              key={index}
              className={styles.simpleStatsCard}
            >
              <header className={styles.simpleStatsCardHeader}>
                <div className={styles.simpleStatsCardHeaderRow}>
                  <h3 className={styles.simpleStatsCardTitle}>
                    {stat.label}
                  </h3>
                </div>
              </header>

              <div className={styles.simpleStatsCardValueContainer}>
                <p className={styles.simpleStatsCardValue}>
                  {stat.value}
                </p>
              </div>
            </article>
          ))}
        </section>

        <header className={styles.sectionHeader}>
          <div className={styles.sectionHeaderContent}>
            <h2 className={styles.sectionTitle}>
              Revenue
            </h2>
          </div>
        </header>

        <RevenueSection isDistributor={false} />

        <header className={styles.sectionHeader}>
          <div className={styles.sectionHeaderContent}>
            <h2 className={styles.sectionTitle}>
              Trial Performance
            </h2>
          </div>
        </header>

        <TrialPerformanceSection isDistributor={false} />

        <header className={styles.sectionHeader}>
          <div className={styles.sectionHeaderContent}>
            <h2 className={styles.sectionTitle}>
              Top 5 Sales Rep
            </h2>
          </div>
        </header>

        <SalesPerformanceSection />
      </article>
    );
  }

  return (
    <article className={styles.container}>
      <DateFilterDropdown />

      <header className={styles.sectionHeader}>
        <div className={styles.sectionHeaderContent}>
          <h2 className={styles.sectionTitle}>
            Trial Performance
          </h2>
        </div>
      </header>

      <TrialPerformanceSection />

      <header className={styles.sectionHeader}>
        <div className={styles.sectionHeaderContent}>
          <h2 className={styles.sectionTitle}>
            Revenue
          </h2>
        </div>
      </header>

      <RevenueSection />
      <TopSalesRepSection />
    </article>
  );
};